import * as React from "react";
import { Eye, LucideIcon } from "lucide-react";
import { Alert } from "@/components/ui";

interface ReadOnlyNoticeProps {
  title: string;
  body: string;
  icon?: LucideIcon;
  className?: string;
}

export const READ_ONLY_NOTICE = {
  title: "View only",
  body: "You can look at this design and its previews. Ask your coach for edit access to make changes.",
};
export const ARCHIVED_NOTICE = {
  title: "This design is archived",
  body: "Restore it to refine or publish it again.",
};
export const GLOBAL_NOTICE = {
  title: "This is a global template",
  body: "Add it to your designs to refine and publish your own version.",
};

export const ReadOnlyNotice: React.FC<ReadOnlyNoticeProps> = ({ title, body, icon: Icon = Eye, className }) => (
  <Alert className={className}>
    <Icon aria-hidden="true" />
    <Alert.Title>{title}</Alert.Title>
    <Alert.Description>{body}</Alert.Description>
  </Alert>
);
